import { styled } from "@mui/material"

type ToolbarPositionProps = {
  visible: boolean
  anchor: "left" | "right" | "bottom"
  style?: React.CSSProperties
}

export const ToolbarPosition = styled("div")<ToolbarPositionProps>({
  position: "absolute",
  display: "flex",
  justifyContent: "center",
  // allow clicks on the positioning div to pass through
  // but children should be clickable
  pointerEvents: "none",
  "& > *": {
    pointerEvents: "auto",
  },
  variants: [
    {
      props: { anchor: "left", visible: true },
      style: { left: 18 },
    },
    {
      props: { anchor: "left", visible: false },
      style: { left: 0, opacity: 0, pointerEvents: "none" },
    },
    {
      props: { anchor: "right", visible: true },
      style: { right: 18 },
    },
    {
      props: { anchor: "right", visible: false },
      style: { right: 0, opacity: 0, pointerEvents: "none" },
    },
    {
      props: { anchor: "bottom", visible: true },
      style: { bottom: 18 },
    },
    {
      props: { anchor: "bottom", visible: false },
      style: { bottom: -60, opacity: 0, pointerEvents: "none", zIndex: -1 },
    },
  ],
  transition: "left 0.2s, right 0.2s, bottom 0.2s, top 0.2s, opacity 0.2s",
})
